<div class="modal fade" [id]="name" role="dialog" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered" [ngClass]="modalSizeClass" role="document">
    <div class="modal-content rounded shadow-modal shadow-modal">
      <div class="modal-header" *ngIf="hasHeader || title">
        <ng-container *ngIf="hasHeader; else titleEl" [ngTemplateOutlet]="header"></ng-container>
        <ng-template #titleEl>
          <h5 class="modal-title">
            {{ title }}
          </h5>
        </ng-template>
        <button (click)="closeModal()" class="close">
          <svg class="icon">
            <use xlink:href="assets/svg/sprite.svg#it-close"></use>
          </svg>
        </button>
      </div>
      <div class="modal-body" *ngIf="isActive">
        <ng-content></ng-content>
      </div>
      <div class="modal-footer" *ngIf="hasFooter">
        <ng-container [ngTemplateOutlet]="footer"></ng-container>
      </div>
    </div>
  </div>
</div>
